import type { DocPageContent } from '../docs-content'

const page = {
  order: 10,
  slug: 'properties',
  title: '片段属性',
  description: '变换、裁剪、不透明度、混合、播放、淡入淡出、文本、形状和混合值。',
  category: '核心编辑',
  sections: [
    {
      title: '选择行为',
      items: [
        '选择一个片段进行详细编辑。',
        '选择多个片段以同时更改共享属性。',
        '混合值表示选中的片段当前不共享相同的设置。',
      ],
    },
    {
      title: '通用控件',
      items: [
        '使用"变换"调整位置、大小、旋转和锚点。',
        '使用"裁剪"控件进行边缘裁剪和柔化。',
        '使用"不透明度"和"混合"模式进行合成。',
        '使用"播放"控件调整速度和相关片段时间。',
      ],
    },
    {
      title: '类型特定控件',
      items: [
        '使用"音频"控件调整增益、淡入淡出、音高和均衡器。',
        '使用"文本"控件调整内容、字体、颜色、对齐、背景和动画。',
        '使用"形状"控件调整形状类型、路径、填充、描边、蒙版和羽化。',
        '使用"字幕"控件调整转录提示和字幕样式。',
      ],
    },
  ],
} satisfies DocPageContent

export default page